import { graphql } from '@/gql';
import type { MessagesQueryVariables } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { PaginatedMessageTypeResponse } from '@/models/chatRoom';

export const fetchMessages = async ({ chatRoomId, pagination }: MessagesQueryVariables): Promise<PaginatedMessageTypeResponse> => {
  const response = await queryExecute({
    query: graphql(`
      query Messages($pagination: MessagePaginationInputType, $chatRoomId: String) {
        messages(pagination: $pagination, chatRoomId: $chatRoomId) {
          count
          nextCursor {
            createdAt
            id
          }
          rows {
            id
            chatRoomId
            fromNumber
            message
            isRead
            createdAt
            updatedAt
          }
        }
      }
    `),
    variables: {
      chatRoomId,
      pagination,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data.messages;
};
